export const gallicResearch =[
    { name: "Swordsman", wood: 940, clay: 700, iron: 1680, crop: 520, all: 3840 },
    { name: "Pathfinder", wood: 1120, clay: 700, iron: 360, crop: 400, all: 2580 },
    { name: "Theutates Thunder", wood: 2200, clay: 1900, iron: 2040, crop: 520, all: 6660 },
    { name: "Druidrider", wood: 2260, clay: 1420, iron: 2440, crop: 880, all: 7000 },
    { name: "Haeduan", wood: 3100, clay: 2580, iron: 5600, crop: 1180, all: 12460 },
    { name: "Ram", wood: 5800, clay: 2320, iron: 2840, crop: 610, all: 11570 },
    { name: "Trebuchet", wood: 5860, clay: 5900, iron: 5240, crop: 700, all: 17700 },
    { name: "Chieftain", wood: 15875, clay: 22900, iron: 25200, crop: 22660, all: 86635 }
]